import {HeartFillIcon, HeartIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import styles from '../SponsorButton.module.css'

/** Heart icon for sponsor buttons — filled when sponsoring, with pulse animation when not. */
export function SponsorHeartIcon({
  isSponsoring,
  suppressAnimation,
}: {
  isSponsoring: boolean
  suppressAnimation?: boolean
}) {
  const Icon = isSponsoring ? HeartFillIcon : HeartIcon
  const animate = !isSponsoring && !suppressAnimation

  return (
    <Icon
      className={clsx('color-fg-sponsors', styles.sponsorIcon, {
        'anim-pulse-in': animate,
      })}
    />
  )
}
